import type { QuoteDetailPublic } from "@common/client"
import { z } from "zod"
import { isPartsQuote } from "./parts-quote"

export const TABS = [
  "overview",
  "items",
  "customers",
  "asset",
  "sales",
  "parts",
  "dates",
  "tax",
  "playbooks",
  "reports",
  "activity",
] as const

export const tabSchema = z.enum(TABS)

export type Tab = z.infer<typeof tabSchema>

export function tabsFor(
  quote: QuoteDetailPublic,
  canReadChecks: boolean,
): readonly Tab[] {
  return TABS.filter(
    (tab) =>
      (tab !== "asset" || !isPartsQuote(quote)) &&
      (tab !== "playbooks" || canReadChecks),
  )
}

export function tabLabel(tab: Tab): string {
  switch (tab) {
    case "overview":
      return "Overview"
    case "items":
      return "Items"
    case "customers":
      return "Customers"
    case "asset":
      return "Asset"
    case "sales":
      return "Sales"
    case "parts":
      return "Parts"
    case "dates":
      return "Dates"
    case "tax":
      return "Tax"
    case "playbooks":
      return "Playbooks"
    case "reports":
      return "Reports"
    case "activity":
      return "Activity"
  }
}
